export function normalizeRealtimeUsername(username) {
    if (!username) {
        return null;
    }
    const trimmed = username.trim().replace(/^@/, '').toLowerCase();
    return trimmed.length > 0 ? trimmed : null;
}
/** Socket.IO emits needed to move from one show/cams subscription to the next. */
export function showRealtimeSubscriptionEmits(prev, next) {
    const emits = [];
    const prevUsername = normalizeRealtimeUsername(prev.username);
    const nextUsername = normalizeRealtimeUsername(next.username);
    if (prevUsername && prevUsername !== nextUsername) {
        emits.push(['unsubscribe:presence', prevUsername]);
        emits.push(['unsubscribe:model', prevUsername]);
    }
    if (nextUsername && nextUsername !== prevUsername) {
        emits.push(['subscribe:presence', nextUsername]);
        emits.push(['subscribe:model', nextUsername]);
    }
    const prevShowId = prev.showId ?? null;
    const nextShowId = next.showId ?? null;
    if (prevShowId && prevShowId !== nextShowId) {
        emits.push(['unsubscribe:show', prevShowId]);
    }
    if (nextShowId && nextShowId !== prevShowId) {
        emits.push(['subscribe:show', nextShowId]);
    }
    if (prev.cams && !next.cams) {
        emits.push(['unsubscribe:cams']);
    }
    if (next.cams && !prev.cams) {
        emits.push(['subscribe:cams']);
    }
    return emits;
}
//# sourceMappingURL=realtime-subscription.js.map